export default "__VITE_ASSET__CUf2D$O3__"